 


import { HostBinding,Renderer2,HostListener,AfterViewChecked,ChangeDetectorRef,ElementRef,ViewChild,ViewChildren,QueryList,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation} from '@angular/core';

import   html2canvas from 'html2canvas';

declare var $ : any;

import {SectionComponent} from '../../sections/section.component';

import {BoxComponent} from '../../boxes/boxes.component';

import {MessageService} from '../../message.service';

import {SearchPanelComponent} from '../../panel/searchPanel.component';

import { ToastrService } from 'ngx-toastr';

import {NewsletterService} from '../../services/newsletter.service';

import{ArticleService} from '../../services/article.service';

import{CalendarService} from '../../services/calender.service';

import {Subscription} from 'rxjs';

import { Router,ActivatedRoute } from '@angular/router';

import {AppSettings} from '../../settings';

import {BaseComponent} from '../base/base.component';

import {HomeService} from '../../services/home.service';

import {NgbdModalBasic} from '../../dashboard/modals/calender_invite_modal/invite_modal.component';

import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import{TemplateService} from '../../services/template.service';

import{CommonService} from '../../services/common.service';

import * as moment from 'moment';

@Component({
  selector: 'dashboard-chart',
  templateUrl: './DashboardCharts.component.html',
  styleUrls: ['./DashboardCharts.component.css'],
  encapsulation:ViewEncapsulation.None,
  host: {
    '(document:click)': 'onClick($event)',
  }
})
export class DashboardChartComponent  extends BaseComponent implements OnInit,OnChanges,OnDestroy,AfterViewInit,AfterViewChecked{

  @HostBinding('style.width') public width: string = '100%'; 

  title = 'emailtemplates';

  sendArray:any=[];

  modified_newsletter:any=[];


  showMsg:boolean =true;

  newsSubscription:Subscription;

  bannerImage:any ;

  snapImage:any;

  srchTxt:string;

  showPanelIndex:number = 0;

  msg:any;

  token:string='';

  toastr:any;

  homeservice:any;

  _router:any;
  
  newsletterid:number=0;

  // Dynamic text blocks are edited inline with TinyMCE and switched to static HTML while the page is snapshotted.
  switchDynamicTextbox:boolean=false;

  dynamicTextBoxContent:any[]=[];

  dynamicTextBoxInit:any={
    base_url: '/assets',
    nowrap: false,
    importcss_append: true,
    content_css: ['/assets/css/screen.css', '/assets/css/developer.css'],
    menubar: false,
    statusbar: false,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks fullscreen',
      'insertdatetime table paste help wordcount media'
    ],
    extended_valid_elements: 'iframe[src|frameborder|style|scrolling|class|width|height|name|align]',
    image_advtab: true,
    toolbar: 'insertfile undo redo| alignleft aligncenter alignright alignjustify | bold italic underline| bullist numlist | image link media | forecolor backcolor | copy mypaste | table styleselect',
    color_map: [
      '000000', 'Black',
      'FFFFFF', 'White',
      'ED0000', 'Red'
    ],
    custom_colors: false,
    setup: function (editor) {
      editor.ui.registry.addButton('mypaste', {
        tooltip: 'Paste',
        icon: 'paste',
        onAction: () => {
          let html = localStorage.getItem('contentcopy')
          if (html != undefined) {
            editor.setContent('')
            editor.insertContent(html);
          }
        },
      });
    },
    style_formats: [
      { title: 'Header styles' },
      { title: 'Article Grey Header', block: 'p', classes: 'header1' },
      { title: 'Table styles' },
      { title: 'Full Border Table', selector: 'table', classes: 'table1' },
      { title: 'No Border Table', selector: 'table', classes: 'table2' },
      { title: 'Header Black Table', selector: 'table', classes: 'table3' }
    ],
    content_style: '.table1 {width:100%;border:1px solid #000;}' +
      '.table1 tr:not(:last-child) td {border-bottom:1px solid #000;}' +
      '.table1 td:not(:last-child) {border-right:1px solid #000;}' +
      '.table1 td {padding:15px;}' + '.table1 td:first-child {width:70%;}' +
      '.table2 {width:100%;border:1px dashed #ccc;}' +
      '.table2 tr:not(:last-child) td {border-bottom:1px dashed #ccc;}' +
      '.table2 td:not(:last-child) {border-right:1px dashed #ccc;}' +
      '.table2 td {padding:15px;}' +
      '.table2 td:first-child {width:40%;font-weight:900;}' +
      '.table3 {width:100%;border:1px solid #666;}' +
      '.table3 tr:not(:last-child) td {border-bottom:1px solid #666;}' +
      '.table3 td:not(:last-child) {border-right:1px solid #666;}' +
      '.table3 td {padding:10px;}' +
      '.table3 th {padding:10px;}' +
      '.table3 tr:first-child td {background-color:#000;font-weight:900;color:#fff;text-transform:capitalize;}' +
      '.table3 th {background-color:#000;font-weight:900;color:#fff;text-transform:capitalize;}' +
      '.header1 {font-size: 20px !important; padding: 10px 15px; text-transform: uppercase; font-weight: bold; background-image: linear-gradient(to right, #eee, rgba(255,255,255,0));}'
  };
  
 finalJson:any={

    templateName:'',
    image:'',
    sections:{
      bannerImage:'',
      sectionData:'',
      menuSetting:''
    }

   };

   loader_image:boolean=false

   dropdownSettings = {};

   footerDescription:any='<p>To view this Newsletter Correctly please ensure you have a Mitsubishi Motors official MMC OFFICE fonts installed on your PC</p>';

   headerDescription:any='<div class="black-bg"><h1 class="template-header"><img class="black-hld-logo header-image"  src="'+AppSettings.API_ENDPOINT+'images/logo.png">&nbsp;&nbsp;&nbsp;After Sales Newsletter</h1></div>';
   countryGroup: any = []
   countryList = [];
   country = [
    { key: 'Australia', value: 'Australia' },
    { key: 'Austria', value: 'Austria' },
    { key: 'Bahrain', value: 'Bahrain' },
    { key: 'Belgium', value: 'Belgium' },
    { key: 'Bosnia & Herzegovina', value: 'Bosnia & Herzegovina' },
    { key: 'Bulgaria', value: 'Bulgaria' },
    { key: 'Canada', value: 'Canada' },
    { key: 'Croatia', value: 'Croatia' },
    { key: 'Cyprus', value: 'Cyprus' },
    { key: 'Czech Republic', value: 'Czech Republic' },
    { key: 'Denmark', value: 'Denmark' },
    { key: 'Estonia', value: 'Estonia' },
    { key: 'Finland', value: 'Finland' },
    { key: 'France', value: 'France' },
    { key: 'Germany', value: 'Germany' },
    { key: 'Greece', value: 'Greece' },
    { key: 'Hungary', value: 'Hungary' },
    { key: 'Iceland', value: 'Iceland' },
    { key: 'India', value: 'India' },
    { key: 'Ireland', value: 'Ireland' },
    { key: 'Israel', value: 'Israel' },
    { key: 'Italy', value: 'Italy' },
    { key: 'Japan', value: 'Japan' },
    { key: 'Latvia', value: 'Latvia' },
    { key: 'Lithuania', value: 'Lithuania' },
    { key: 'Luxembourg', value: 'Luxembourg' },
    { key: 'Macedonia', value: 'Macedonia' },
    { key: 'Malaysia', value: 'Malaysia' },
    { key: 'Malta', value: 'Malta' },
    { key: 'Moldova', value: 'Moldova' },
    { key: 'Netherlands', value: 'Netherlands' },
    { key: 'New Zealand', value: 'New Zealand' },
    { key: 'Norway', value: 'Norway' },
    { key: 'Palestine', value: 'Palestine' },
    { key: 'Phillipines', value: 'Phillipines' },
    { key: 'Poland', value: 'Poland' },
    { key: 'Portugal', value: 'Portugal' },
    { key: 'Qatar', value: 'Qatar' },
    { key: 'Montenegro', value: 'Montenegro' },
    { key: 'Serbia', value: 'Serbia' },
    { key: 'Romania', value: 'Romania' },
    { key: 'Russia', value: 'Russia' },
    { key: 'Saudi Arabia', value: 'Saudi Arabia' },
    { key: 'Slovakia', value: 'Slovakia' },
    { key: 'Slovenia', value: 'Slovenia' },
    { key: 'South Africa', value: 'South Africa' },
    { key: 'Spain', value: 'Spain' },
    { key: 'Sweden', value: 'Sweden' },
    { key: 'Switzerland', value: 'Switzerland' },
    { key: 'Thailand', value: 'Thailand' },
    { key: 'Turkey', value: 'Turkey' },
    { key: 'Ukraine', value: 'Ukraine' },
    { key: 'United Arab Erimates', value: 'United Arab Erimates' },
    { key: 'United Kingdom', value: 'UK' },
    { key: 'United States of America', value: 'United States of America' }

  ];
   selectedCountry = [];
   dropdownSettings3 = {};

  showHide($event:any){



    this.showPanelIndex = $event.index;

  }
  url:any=AppSettings.API_ENDPOINT

  @HostListener('window:scroll', ['$event'])

    onWindowScroll($event) {

          // use for scrolling
         if(this.navSectionIndex!=undefined && this.navSectionIndex!=-1){

          let nextIndex =this.navSectionIndex;


          if($event.target['scrollingElement'].scrollTop > $('#sect_'+nextIndex).offset().top){


            this.navSectionStyle={

              display:'none'
           }

            this.navSectionIndex =-1;

          }



         }


    }


  section_item:number =1;

  navSettingIndex:number;
  navSettingStyle:any;
  navSectionIndex:number;
  navSectionStyle:any;
  navSettingHeader:string;
  removeSettingDialog:any;
  sectionRemoveId:number;

  currentSectionIndex:number;

  templateName:any;
  templateNumber:any;
  publish:any;
  checkedval:boolean=false;
  checkedExternal:boolean=false;


 //default json

  sections:Array<any>=[{"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"top_story",setting:{
    tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
    subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
    contentCss:{"style":{'color':'#000000','font-size':'16px'}},
    readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
  },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1},{"layout":1,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"main_story",setting:{
    tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
    subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
    contentCss:{"style":{'color':'#000000','font-size':'16px'}},
    readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
  },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1},{"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"reminder_item",setting:{
    tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
    subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
    contentCss:{"style":{'color':'#000000','font-size':'16px'}},
    readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
  },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1},{"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"technical_item",setting:{
    tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
    subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
    contentCss:{"style":{'color':'#000000','font-size':'16px'}},
    readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
  },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1}];

  //sections:Array<any>=[];





  @ViewChildren(SectionComponent) sect ! : QueryList<SectionComponent>;
  @ViewChild("insideElement",{static: false}) insideElement;
  @ViewChild("sectionElement",{static: false}) sectionElement;
  @ViewChild("backimage",{static: false}) backimage;

  @ViewChild("previmage",{static: false}) previmage;
  @ViewChild("settingico",{static: false}) settingico;

  @ViewChildren("inifont") inifont : QueryList<any>;


  rsetting:any=[];

  sectionSetting:any =[];

  menuSetting:Array<any>=[
    {
      type:'top_story',
      settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
  
        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,
  
        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,
  
        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,
  
        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
      }
    },
    {
      type:'main_story',
      settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
        
        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,
  
        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,
  
        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,
  
        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
      }
    },
    {
       type:'reminder_item',
       settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
        
        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,
  
        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,
  
        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,
  
        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
       }
    },
    {
      type:'technical_item',
      settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
        
        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,

        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,

        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,

        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
      }
    },
    {
      type:'dynamic_text_block',
      settings:{
        tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
        contentCss:{"style":{'color':'#000000','font-size':'16px'}},
        readmoreCss:{"style":{'display':'none'}},

        selectedTittleColorID:0,
        selectedTittleTextAlignmentID:0,
        selectedTittleFontStyleID:0,
        selectedTittleFontSizeID:0,

        selectedSubTittleTextAlignmentID:0,
        selectedSubTittleFontStyleID:0,
        selectedSubTittleColorID:0,

        selectedContentTextAlignmentID:0,
        selectedContentFontStyleID:0,
        selectedContentColorID:0,

        selectedLinkTextAlignmentID:0,
        selectedLinkFontStyleID:0,
        selectedLinkColorID:0
      }
    }
  ]
  navigation:Array<any>=[]
 
  templateGroupList:any =[]

  selectedGroup:any=[];

  //{key: "3", value: "template 2"}


  commonService:any;

  permissions:any=[];


  constructor(private _cos:CommonService, private modalService: NgbModal,private calService:CalendarService, private route: ActivatedRoute,homeservice:HomeService,_router: Router,private newsService:NewsletterService , toastr: ToastrService,private renderer: Renderer2, msg:MessageService,private _eref: ElementRef,private articleService:ArticleService,private templateService:TemplateService){

    super(msg,toastr,homeservice,_router);




    try{
        

      this.msg = msg;
      this.toastr = toastr;
      this.homeservice = homeservice;
      this._router =_router;
      this.commonService= _cos;
      this.newsletterid = +this.route.snapshot.paramMap.get('id');

     

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
    
      tokenA = JSON.parse(tokenA);

      this.token = tokenA.token;


      let data2={
        token:this.token, 
        details: {}
      } 
      // get template list
  
      this.templateService.getTemplateList(data2).subscribe( (elem)=>{
  
          if(elem.status =='success'){
             
            this.permissions =elem.permission;


            let result = []
            elem.template.map((x)=>{

              let obj={}
              obj['key']= x.id;
              obj['value'] = x.name

              result.push(obj)

            })
            this.templateGroupList=result

            if(this.newsletterid){


              this.finalJson.id = this.newsletterid;
      
      
                  let data={
                    token:tokenA.token,
                    id:this.newsletterid,
                    'page':'newsletter'
                  }
            
            
            
                  this.newsService.newsletterDataById(data).subscribe( (elem)=>{
      
      
                    
              
              
                      //console.log(elem);
      
                      this.modified_newsletter = elem.newsletter[0];
      
                      let permissions = (elem.permission !=undefined || elem.permission!=null)? elem.permission:[];
      
                      let p =  this.modified_newsletter.status !='Sent' &&  this.commonService.check_newsletter_mange_exists(permissions) ;
      
                      
                      if(!p){
        
                                
                       toastr.error(' You dont have the permission to edit the newsletter  !', '', {timeOut: 3000});
              
                       this._router.navigate(['/newsletter']);
                       
        
                      }
                      

                      if (elem.newsletter[0].country != undefined) {
                        let country = []
                        elem.newsletter[0].country.map((x) => {
                          let obj = {}
                          obj['key'] = x.toUpperCase()
                          obj['value'] = x
                          country.push(obj)
                        })
                        this.selectedCountry = country
                      }
                     
                   
                      //this.templateName = elem.;
                      this.templateName =  elem.newsletter[0].templateName;
                      this.templateNumber = elem.newsletter[0].templateNumber;
                      this.publish = elem.newsletter[0].publish;
      
                      if(elem.newsletter[0] && elem.newsletter[0].private){
                        if(elem.newsletter[0].private ==1){
                          this.checkedval = true;
                        }else{
                          this.checkedval = false;
                        }
                        
                      }

                      if(elem.newsletter[0] && elem.newsletter[0].external){
                        if(elem.newsletter[0].external ==1){
                          this.checkedExternal = true;
                        }else{
                          this.checkedExternal = false;
                        }
                        
                      }
      
                      if(elem.newsletter[0].templateId!=undefined){
                        
                        let obj=[];
      
                        this.templateGroupList.map((x)=>{
      
                            if(x.key ==elem.newsletter[0].templateId){
                               obj.push(x)
                            }
                        })
      
                         this.selectedGroup = obj
                        
                        
                      }
      
                      
                      if( elem.newsletter[0].sections!=null &&elem.newsletter[0].sections.bannerImage!=undefined &&elem.newsletter[0].sections.bannerImage!=null){
      
                        this.bannerImage = elem.newsletter[0].sections.bannerImage;
      
                        var img:any = document.createElement('img');
      
                        if(this.bannerImage!=undefined && this.bannerImage!=''){
      
                          img.src= AppSettings.API_ENDPOINT+this.bannerImage;
      
                        } else{
      
                          img.src= '';
                        }
      
                        //
      
                        img.height ='200';
                        img.style.width = '100%';
                        img.style['object-fit']='cover';
        
        
        
        
                        // this.backimage.nativeElement.innerHTML='';
        
                        // this.previmage.nativeElement.innerHTML='';                 
        
        
                        // this.renderer.appendChild(this.backimage.nativeElement, img.cloneNode(true));
        
                        // this.renderer.appendChild(this.previmage.nativeElement, img.cloneNode(true));
        
      
                      } else {
                        
                        this.bannerImage = '';
      
                      }
      
                      
                      if(elem.newsletter[0].sections!=null && elem.newsletter[0].sections.sectionData!=undefined){
                       
                       this.sections = elem.newsletter[0].sections.sectionData;
                       this.prepareDynamicTextBlocks();
      
                       console.log("section 1 ====",this.sections);
      
                      }
      
                      if(elem.newsletter[0].sections!=null && elem.newsletter[0].sections.menuSetting !=undefined){
      
                        this.menuSetting = elem.newsletter[0].sections.menuSetting; 
      
                      }
      
                      if(elem.newsletter[0].sections!=null){
                          
                      this.footerDescription = elem.newsletter[0].sections.footer;
                      this.headerDescription =  elem.newsletter[0].sections.header;
                    
                 
                      }
      
                      articleService.articleData({
                        token:tokenA.token,
                        group:'type',
                        'page':'newsletter'
      
                      }).subscribe( (res) =>{
      
                      if(res.status=='success'){  
      
                      
                       this.msg.sendMessage({'user':res.user.name,'notification':res.notification,'type':'left_menu_link','navigations':res.navigation})
      
      
                      this.navigation=res.article;
      
      
                      if(this.navigation.length>0 && this.menuSetting.length > 0){
      
                      for(let i=0;i<this.navigation.length;i++){
      
                      if(this.menuSetting[i]!=undefined && this.menuSetting[i].type == this.navigation[i].type){
      
                      this.navigation[i].setting=this.menuSetting[i].settings
      
                      }
                      }
      
                      }
      
                      }else{
      
                      _router.navigate(['/login']); 
                      }
      
                      })
      
              
                  });
      
               
      
                  
      
            } else{
      
      
              articleService.articleData({
                token:tokenA.token,
                group:'type',
                'page':'newsletter'
              }).subscribe( (res) =>{
      
              if(res.status=='success'){  
      
      
              this.navigation=res.article;
      //use for left menu
              this.msg.sendMessage({'user':res.user.name,'type':'left_menu_link','navigations':res.navigation})
      
              
      
              if(this.navigation.length>0 && this.menuSetting.length > 0){
      
              for(let i=0;i<this.navigation.length;i++){
      
              if(this.menuSetting[i]!=undefined && this.menuSetting[i].type == this.navigation[i].type){
      
              this.navigation[i].setting=this.menuSetting[i].settings
      
              }
              }
      
              }
      
              }else{
      
              _router.navigate(['/login']); 
              }
      
              })
            }
         
            
          }
  
        });

 }catch(exc){
     
   _router.navigate(['/login']);

 } 



  }





  openShare(){

    if(this.hasDynamicTextBlock()){
      this.loader_image = true
      this.switchDynamicTextbox = true
      setTimeout(() => this.captureAndShare(), 1000)
    }else{
      this.captureAndShare()
    }
  }

  captureAndShare(){


   this.showMsg =true;
   this.loader_image=true;

   $('#hide_below_snapshot').hide();

   window.scrollTo(0,0);

   // take a screenshoot
  
  html2canvas(document.getElementById('ss2'),{ allowTaint: true, useCORS: true  
  }).then(canvas => {
   
    
      var tempcanvas=document.createElement('canvas');

      tempcanvas.width=canvas.width ;
      tempcanvas.height=canvas.height;
      var context=tempcanvas.getContext('2d');

     

   

     context.drawImage(canvas, 0, 0, tempcanvas.width,tempcanvas.height );


    var link=document.createElement("a");
    link.href=tempcanvas.toDataURL('image/png');   //function blocks CORS

  //  link.download = this.templateName+'.png';
    //link.click();


    $('#hide_below_snapshot').show();
    this.switchDynamicTextbox = false;
    


    try{
      let res:any = link.href;
      let token:any = JSON.parse(atob(localStorage.getItem('token')));
      var data = new FormData();
      data.append( 'upload[0][content]',res);
      data.append( 'upload[0][name]',this.templateName);

      let obj={
        token:token,
        reqData:data
      }

      this.newsService.imageUpload(obj).subscribe( (res) =>{
       // console.log('ffffkkkkkkkk',res)

        if(res.status=='success'){

        // document.getElementById('capture').style.display='none';

        //  this.snapImage = this.url+res.files[0].path;

        //$('#render-snapshot').html('');

         this.snapImage = res.files[0].path;




 

   let is_blank=0;

   let total_element =0;

   this.sections.forEach( (items)=>{
     

       items.elements.forEach( (items2)=>{

        total_element++;

         if(items2.navObject!=undefined && items2.navObject.id !=undefined){
              
            is_blank++;

 


         }

       });

   });


   

   if(is_blank > 0 && total_element> 0 && (is_blank == total_element )){

    

   // this.saveImageForSend();


      this.loader_image=false;
 
       const modalRef1 = this.modalService.open(NgbdModalBasic,{ windowClass : "invite_popup new_invite_popup"});
 
        modalRef1.componentInstance.month = false;
    
        modalRef1.componentInstance.year =false;    

        console.log("modified_newsletter====",this.modified_newsletter);


        modalRef1.componentInstance.newsletterI = this.modified_newsletter;
     
        modalRef1.componentInstance.finalShare=true;
         
 
        modalRef1.componentInstance.passEntry.subscribe((receivedEntry) => {


 
          modalRef1.close();


          

          this.modified_newsletter.send= receivedEntry.invite.invite; 

          
          if(receivedEntry.invite.sections==null){

           receivedEntry.invite.sections ={};
    
           receivedEntry.invite.sections.bannerImage=this.bannerImage;
           receivedEntry.invite.sections.sectionData=this.sections;
           receivedEntry.invite.sections.menuSetting=this.menuSetting;

           receivedEntry.invite.sections.footer = this.footerDescription 
           receivedEntry.invite.sections.header =   this.headerDescription 





          }

       
          // recieve entry image works

          receivedEntry.invite.image = this.snapImage; 
          
            
       
         

          if(receivedEntry.sendnow!=undefined && receivedEntry.sendnow==true){

            console.log("1---")

            this.calService.send_invite_now
            ({
            'token':this.token,  
            'details':{
                        id:receivedEntry.invite.id,
                        name: receivedEntry.invite.templateName,
                        publish:receivedEntry.invite.publish,
                        number:receivedEntry.invite.templateNumber,
                        send:receivedEntry.invite.invite,
                      fromname: receivedEntry.fromname,
                      fromemail: receivedEntry.fromemail,
                        schedule:'' ,
                        sendnow:true,
                        sections: receivedEntry.invite.sections ,
                        image: receivedEntry.invite.image,  
                        country: receivedEntry.invite.country,
                        'page':'newsletter'
                      },
  
   
            }).subscribe( (evt)=>{
   
                 if(evt.status =='success'){
   
                    this.toastr.success('Newsletter sent successfully', '', {timeOut: 3000});
                    this._router.navigate(['/newsletter']);

   
                 }else{
   
                   this.toastr.success('Newsletter sent failed', '', {timeOut: 3000});
                  
                 }
   
                 });




          }else if(receivedEntry.draft!=undefined && receivedEntry.draft==true){


            console.log("2====",receivedEntry);


            this.calService.send_invite_now
            ({
            'token':this.token,  
            'details':{
                        id:receivedEntry.invite.id,
                        name: receivedEntry.invite.templateName,
                        publish:receivedEntry.invite.publish,
                        number:receivedEntry.invite.templateNumber,
                        send:receivedEntry.invite.invite,
                      fromname: receivedEntry.fromname,
                      fromemail: receivedEntry.fromemail,
                        schedule:'',
                        draft:true,
                        sections: receivedEntry.invite.sections ,
                        image: receivedEntry.invite.image,  
                        country: receivedEntry.invite.country,
                        'page':'newsletter'
                      },
  
   
            }).subscribe( (evt)=>{
   
                 if(evt.status =='success'){
   
                    this.toastr.success('Newsletter saved as draft ', '', {timeOut: 3000});
                    this._router.navigate(['/newsletter']);

   
                 }else{
   
                   this.toastr.success('Newsletter save failed', '', {timeOut: 3000});
                  
                 }
   
                 });


               


          }else{


            let timeNow= receivedEntry.sdate+' '+receivedEntry.time.hour+':'+receivedEntry.time.minute;

              
           // console.log(receivedEntry);

            let timeutc = moment(timeNow, "YYYY-MM-DD HH:mm").utc().format("YYYY-MM-DD HH:mm");


           // console.log(timeutc);

            console.log("3-====")
            
            this.calService.send_invite_now
            ({
            'token':this.token,  
            'details':{
                        id:receivedEntry.invite.id,
                        name: receivedEntry.invite.templateName,
                        publish:receivedEntry.invite.publish,
                        number:receivedEntry.invite.templateNumber,
                        send:receivedEntry.invite.invite,
                      fromname: receivedEntry.fromname,
                      fromemail: receivedEntry.fromemail,
                        schedule:timeutc ,
                        schedulenow:true,
                        sections: receivedEntry.invite.sections ,
                        image: receivedEntry.invite.image,  
                        country: receivedEntry.invite.country,
                        'page':'newsletter'
                      },
  
   
            }).subscribe( (evt)=>{
   
                 if(evt.status =='success'){
   
                    this.toastr.success('Newsletter scheduled successfully', '', {timeOut: 3000});

                    this._router.navigate(['/newsletter']);
   
                 }else{
   
                   this.toastr.success('Newsletter scheduled failed', '', {timeOut: 3000});
                  
                 }
   
                 });

                  

          }
    

       
       
              
 
       
              
 
    
 
 
    });



   } else{
      
    this.toastr.warning('Please Complete the Newsletter !', '', {timeOut: 3000});

    window.scrollTo(0, 0);
    this.loader_image=false;


   }


  } else{


  }

});

    }catch(e){




    }


  });

   
  }





  uploadBanner($event){


    // upload banner in newsletter
    this.processFiles($event.target.files);

  }

  setImageBanner(){


    
    $("#bannerImage").trigger("click");


  }

  processFiles(files){

    for (var i=0, file; file=files[i]; i++) {
        if (file.type.match(/image.*/)) {
            let file = files[i];
            var reader = new FileReader();

            reader.onload = function(e2) {
                // finished reading file data.
                var img:any = document.createElement('img');
                img.src= e2.target.result;
                img.height ='240';
                img.style.width = '100%';
                img.style['object-fit']='cover';

                this.backimage.nativeElement.innerHTML='';

                this.previmage.nativeElement.innerHTML='';

                this.bannerImage =e2.target.result;

                $('.bannerImg').addClass('p-0');

                this.renderer.appendChild(this.backimage.nativeElement, img.cloneNode(true)); 

                this.renderer.appendChild(this.previmage.nativeElement, img.cloneNode(true));

              
                try{
                  let res:any = reader.result;
                  let token:any = JSON.parse(atob(localStorage.getItem('token')));
                  var data = new FormData();
                  data.append( 'upload[0][content]',res);
                  data.append( 'upload[0][name]',file.name);

                  let obj={
                    token:token,
                    reqData:data
                  }

                  this.newsService.imageUpload(obj).subscribe( (res) =>{

                    if(res.status=='success'){

                    //  this.bannerImage = this.url+res.files[0].path
                     this.bannerImage = res.files[0].path

                    }else{
                      this._router.navigate(['/login']);
                    }

                  })

                }catch(exec){
                  this._router.navigate(['/login']);
                }
               



            }.bind(this);

            reader.readAsDataURL(file); // start reading the file data.
        }
    }

  }

  


  dropv2(e:any){

    e.stopPropagation();
    e.preventDefault();

    this.processFiles(e.dataTransfer.files);


  }

  allowDrop(e:any){

    e.stopPropagation();
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
  }








  drag(ev:any,detail:any,type:string) {



    //ev.dataTransfer.setData("text", JSON.stringify({'classes':ev.target.classList.toString() ,'id':ev.target.id}) );

   // drag a article

      if(ev.dataTransfer!=undefined){

        ev.dataTransfer.setData("text",JSON.stringify({'action':'insert','nav_obj':detail,'type':type}));


      }
      
}



  actionSection(event:any){





    switch(event.action){

     case 'insert_record':


     this.sections[event.evt.pos].elements[event.evt.epos].navObject = event.evt.data.nav_obj;


     this.sect.forEach((div: SectionComponent) =>  {

            if(div.pos == event.evt.pos){

              div.boxes.forEach( (div2: BoxComponent) => {


                    if(div2.belef!=undefined){

                      div2.belef.nativeElement.removeAttribute('style');

                    }


              });


            }

     });



     break;


     case 'swap_record':

              let p = this.sections[event.evt.pos].elements[event.evt.epos];

              this.sections[event.evt.pos].elements[event.evt.epos] = this.sections[event.evt.data.apos].elements[event.evt.data.epos];

              this.sections[event.evt.data.apos].elements[event.evt.data.epos] =p;

     break;


      case 'order':


          if(event.npos >= 0 && event.npos <= this.sections.length -1 ){

            let p = this.sections[event.pos];

            this.sections[event.pos] = this.sections[event.npos];

            this.sections[event.npos] =p;


          }


      break

     case 'update_section':
        this.sections[event.pos]=event.element
       break
    }



  }



  addasection(type:string){


    switch(type){

      case 'top_story':

          this.sections.push({"layout":3,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"top_story",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
          },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1 });


      break;


      case 'main_story':


          this.sections.push({"layout":1,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"main_story",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
          },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1});


      break;


      case 'reminder_item':


          this.sections.push({"layout":4,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"reminder_item",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
          },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1});



      break;


      case 'technical_item':


          this.sections.push({"layout":4,"elements":[{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}},{"navObject":{"headingCss":{},"descriptionCss":{}}}],"type":"technical_item",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'color':'#000000','font-size':'14px','text-transform': 'uppercase','border-bottom': '2px solid #000','padding-bottom': '2px','font-family': 'mmcbold'}},
          },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1});

      break;

      case 'dynamic_text_block':

          // The placeholder id marks the slot as filled for the newsletter completeness check.
          this.sections.push({"layout":1,"elements":[{"navObject":{"id":"999","headingCss":{},"descriptionCss":{}}}],"type":"dynamic_text_block",setting:{
            tittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            subtittleCss:{"style":{'color':'#000000','font-size':'16px'}},
            contentCss:{"style":{'color':'#000000','font-size':'16px'}},
            readmoreCss:{"style":{'display':'none'}},
          },"backgroundCss":{"style":{'background-color':'none'}},'isDividerOn':false,"dividerCss":{"style":{'background-color':'none'}},selectedBackColorID:-1,selectedDividerColorID:-1});

      break;



     }




    $('#exampleModal').modal('hide');

  }

  ngOnInit(){


    this.dropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      closeDropDownOnSelection:true	
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };

    let arr = []
    this.country.map((x) => {
      let obj = {}
      obj['key'] = x.key.toUpperCase()
      obj['value'] = x.value
      arr.push(obj)
    })
    this.countryList = arr
 

    window.scrollTo(0, 0);

    this.navSettingStyle={
      display:'none'
    }
    this.navSectionStyle={
      display:'none'
    }

    let tokenA: any = (localStorage.getItem('token') != undefined) ? atob(localStorage.getItem('token')) : 0;

    if (!tokenA) throw 'Error in parse';

    if (!JSON.parse(tokenA)) throw 'Error in json parse';

    tokenA = JSON.parse(tokenA);


    this.token = tokenA.token;

    let data = {
      token: tokenA.token,
      limit: 20,
      'page': 'settings'
    }

    this.articleService.getCountryGroup(data).subscribe((res) => {
      console.log("coutry grp======",res);

      if (res.status == 'success') {
        this.countryGroup = res.groups
        this.countryGroup.map((x) => {
          x['label'] = x.group
          x['value'] = x.group
          x['isChecked'] = false
        })

      }

    })

   
  }

  process(srch:string){

    this.srchTxt = srch;
  }

  ngAfterViewInit(){


    $(function(){


      $('#accordion .panel').on('click',function(e){
        
      });

      var flag=1;

    }); 


  }


  ngAfterViewChecked(){


    this.sect.forEach((div: SectionComponent) =>  {


       let maxHeight = 0,maxParHeight=0,cardHeight=0

      div.boxes.forEach( (div2: BoxComponent) => {



        this.sections[div2.pos].elements[div2.element_pos].navObject['headingCss']={}
        this.sections[div2.pos].elements[div2.element_pos].navObject['descriptionCss']={}
        this.sections[div2.pos].elements[div2.element_pos].navObject['cardCss']={}

              //  if(div2.telef!=undefined){

              //   if(div2.telef.nativeElement.offsetHeight > maxHeight ){

              //     maxHeight = div2.telef.nativeElement.offsetHeight;
              //   }

              //  }
               if(div2.belef!=undefined){



                if(div2.belef.nativeElement.offsetHeight > maxParHeight ){

                  maxParHeight = div2.belef.nativeElement.offsetHeight;
                }

               }

               if(div2.celef!=undefined){

                if(div2.celef.nativeElement.offsetHeight > cardHeight ){

                  cardHeight = div2.celef.nativeElement.offsetHeight;
                }

               }

      });

      div.boxes.forEach( (div2: BoxComponent) => {

              // if(div2.telef!=undefined){

              //     this.renderer.setStyle(div2.telef.nativeElement, "height", maxHeight+'px');
              //     this.sections[div2.pos].elements[div2.element_pos].navObject.headingCss['fontSize']=maxHeight+'px'
              // }



              if(div2.belef!=undefined){



                this.renderer.setStyle(div2.belef.nativeElement, "height", maxParHeight+'px');
                this.sections[div2.pos].elements[div2.element_pos].navObject.descriptionCss['fontSize']=maxParHeight+'px'

             }

             if(div2.celef!=undefined){
              this.sections[div2.pos].elements[div2.element_pos].navObject.cardCss['fontSize']=cardHeight+'px'
             }

      });

   });



  }

  ngOnChanges(changes:SimpleChanges){


  }

  ngOnDestroy(){

  }






  deleteSection(position: number) {


    this.sectionRemoveId =position;


     this.removeSettingDialog ={
       display:'block'
     }


  

   }


   hideremoveSection(){



     this.removeSettingDialog ={
       display:'none'
     }

   }

     removeSection(){


     this.removeSettingDialog ={
       display:'none'
     }

      this.sections.splice(this.sectionRemoveId,1);

   }


 
 closeModal(){
  $("#preview-modal").modal('hide')
 }

 onCountrySelect($event) {

 }

 onCountrySelectAll($event) {

 }

 onCountryDeSelect($event) {

 }

 onCountryDeSelectAll($event) {

 }

 setMyStyles(val) {

  //   let style={
  //     height:'0px'
  //   }

  //  if(val.navObject.descriptionCss!=undefined && val.navObject.descriptionCss.fontSize!=undefined){

  //    style={
  //     height:val.navObject.descriptionCss.fontSize
  //   }

  //  }
  //  return style
 }


 showSettingLeft($evt){

 
  this.navSetting($evt.evt,$evt.index,$evt.tittle,$evt.settingico);

 }


 navSetting(evt,index,tittle,settingico){

  if(this.navSettingIndex ==index){

    this.navSettingStyle={
      display:'none'
    }

    this.navSettingIndex =-1;

  }else{


  this.navSettingIndex=index
  this.navSettingHeader=tittle

  let lft = settingico.left -240 +42;


  let rht = settingico.top -20;

  if(index ==2){

    rht = rht - 120;

  }

  if(index ==3){

    rht = rht - 150;

  }
  


  this.navSettingStyle={

    display:'block',
    'top':rht+'px',
    'left':lft+'px',
     position:'fixed'
  }
  }
  if(this.navSettingIndex>-1){

    this.rsetting = this.navigation.filter( (item,k) => { return  k == this.navSettingIndex});

   }else{

    this.rsetting =[];
   }

 evt.stopPropagation();

}







onClick(event) {



  if(this.insideElement !=undefined){


    const clickedInside = this.insideElement.nativeElement.contains(event.target);

        if (!clickedInside) {

          this.navSettingStyle={

                display:'none'
          }

          this.navSettingIndex =-1;
        }


      }

      if(this.sectionElement !=undefined ){

        const clickedInside1 = this.sectionElement.nativeElement.contains(event.target);

        if (!clickedInside1) {

          this.navSectionStyle={

                display:'none'
          }

          this.navSectionIndex =-1;
        }



  }





}

onColorChange(value,id){
  if( this.navigation[this.navSettingIndex].setting.selectedTittleColorID==id){
    this.navigation[this.navSettingIndex].setting.selectedTittleColorID=0
    this.navigation[this.navSettingIndex].setting.tittleCss.style.color='#000000'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{
    this.navigation[this.navSettingIndex].setting.selectedTittleColorID=id
    this.navigation[this.navSettingIndex].setting.tittleCss.style.color=value
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
  
  }
  
}
onChangeC(event: any) {

  this.selectedCountry = []
  const { checked, value } = event.target;
  let index = this.countryGroup.length;
  while (index--) {
    this.countryGroup[index].isChecked = value === this.countryGroup[index]['value'];
  }

  let country = []
  this.countryGroup.map((x) => {
    if (x.isChecked == true) {
      x.countries.map((x) => {
        let obj = {}
        obj['key'] = x.toUpperCase()
        obj['value'] = x
        country.push(obj)
      })
    }
  })
  this.selectedCountry = country


}

popupSection(event){



  let fixedBoxOffsetTop =0;

  let fixedBoxOffsetLeft =0;


  this.sect.forEach((div: SectionComponent) =>  {




    if(div.pos == event.s_index){



      fixedBoxOffsetTop = div.set2.nativeElement.getBoundingClientRect().top;

     
      fixedBoxOffsetLeft = div.set2.nativeElement.getBoundingClientRect().left - 268 ;



    }



  });

  this.currentSectionIndex=event.s_index

  if(this.navSectionIndex ==event.s_index){

    this.navSectionStyle={
      display:'none'
    }

    this.navSectionIndex =-1;

  }else{


   // console.log(event.evt.clientY);




  this.navSectionIndex=event.s_index
  this.navSectionStyle={
    display:'block',
    'top':fixedBoxOffsetTop+'px',

    'left': fixedBoxOffsetLeft+'px',
     'position':'fixed',


  }


  }

  if(this.currentSectionIndex>-1){

    this.sectionSetting = this.sections.filter( (item,k) => { return  k == this.currentSectionIndex});

   }else{

    this.sectionSetting =[];
   }

  event.evt.stopPropagation();


}

onAlignmentChange(value,id){
  
  this.navigation[this.navSettingIndex].setting.selectedTittleTextAlignmentID=id
  this.navigation[this.navSettingIndex].setting.tittleCss.style['text-align']=value
  this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

}

onFontStyleChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedTittleFontStyleID==id){
    this.navigation[this.navSettingIndex].setting.selectedTittleFontStyleID=0
    this.navigation[this.navSettingIndex].setting.tittleCss.style['text-decoration']='none'
    this.navigation[this.navSettingIndex].setting.tittleCss.style['font-weight']='normal'
    this.navigation[this.navSettingIndex].setting.tittleCss.style['font-style']='normal'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{

    this.navigation[this.navSettingIndex].setting.selectedTittleFontStyleID=id

    if(value==='underline'){
      this.navigation[this.navSettingIndex].setting.tittleCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-style']='normal'
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }else if(value==='bold'){
      this.navigation[this.navSettingIndex].setting.tittleCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-style']='normal'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-weight']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
    else{
      this.navigation[this.navSettingIndex].setting.tittleCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.tittleCss.style['font-style']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
  }



}

onsubTittleAlignmentChange(value,id){

  this.navigation[this.navSettingIndex].setting.selectedSubTittleTextAlignmentID=id
  this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-align']=value
  this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

}

onSubTittleFontStyleChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedSubTittleFontStyleID==id){

    this.navigation[this.navSettingIndex].setting.selectedSubTittleFontStyleID=0
    this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-decoration']='none'
    this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-weight']='normal'
    this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-style']='normal'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{
    this.navigation[this.navSettingIndex].setting.selectedSubTittleFontStyleID=id

    if(value==='underline'){
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-style']='normal'
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }else if(value==='bold'){
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-style']='normal'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-weight']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
    else{
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-style']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
  }

 }

 onSubTittleColorChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedSubTittleColorID==id){
    this.navigation[this.navSettingIndex].setting.selectedSubTittleColorID=0
    this.navigation[this.navSettingIndex].setting.subtittleCss.style.color='#000000'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{
    this.navigation[this.navSettingIndex].setting.selectedSubTittleColorID=id
    this.navigation[this.navSettingIndex].setting.subtittleCss.style.color=value
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
  
  }
  

 }

onContentAlignmentChange(value,id){

  this.navigation[this.navSettingIndex].setting.selectedContentTextAlignmentID=id
  this.navigation[this.navSettingIndex].setting.contentCss.style['text-align']=value
  this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);


}

onContentFontStyleChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedContentFontStyleID==id){

    this.navigation[this.navSettingIndex].setting.selectedContentFontStyleID=0
    this.navigation[this.navSettingIndex].setting.contentCss.style['text-decoration']='none'
    this.navigation[this.navSettingIndex].setting.contentCss.style['font-weight']='normal'
    this.navigation[this.navSettingIndex].setting.contentCss.style['font-style']='normal'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{

    this.navigation[this.navSettingIndex].setting.selectedContentFontStyleID=id

    if(value==='underline'){
      this.navigation[this.navSettingIndex].setting.contentCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-style']='normal'
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }else if(value==='bold'){
      this.navigation[this.navSettingIndex].setting.contentCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-style']='normal'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-weight']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
    else{
      this.navigation[this.navSettingIndex].setting.contentCss.style['text-decoration']='none'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.contentCss.style['font-style']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
  }

}

onContentColorChange(value,id){
  
  if(this.navigation[this.navSettingIndex].setting.selectedContentColorID==id){
    this.navigation[this.navSettingIndex].setting.selectedContentColorID=0
    this.navigation[this.navSettingIndex].setting.contentCss.style.color='#000000'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{
    this.navigation[this.navSettingIndex].setting.selectedContentColorID=id
    this.navigation[this.navSettingIndex].setting.contentCss.style.color=value
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
  
  }
  

 }

 onLinkAlignmentChange(value,id){

   this.navigation[this.navSettingIndex].setting.selectedLinkTextAlignmentID=id
   this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-align']=value
   this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

 }
 onLinkFontStyleChange(value,id){

  if(this.navigation[this.navSettingIndex].setting.selectedLinkFontStyleID==id){

    this.navigation[this.navSettingIndex].setting.selectedLinkFontStyleID=0
    this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-decoration']='none'
    this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-weight']='normal'
    this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-style']='normal'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

  }else{

    this.navigation[this.navSettingIndex].setting.selectedLinkFontStyleID=id

    if(value==='underline'){
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-style']='normal'
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }else if(value==='bold'){
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-style']='normal'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-weight']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
    else{
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['text-decoration']='underline'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-weight']='normal'
      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-style']=value
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
    }
  }

}

onLinkColorChange(value,id){
  if(this.navigation[this.navSettingIndex].setting.selectedLinkColorID==id){
    this.navigation[this.navSettingIndex].setting.selectedLinkColorID=0
    this.navigation[this.navSettingIndex].setting.readmoreCss.style.color='#000000'
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
  }else{
    this.navigation[this.navSettingIndex].setting.selectedLinkColorID=id
    this.navigation[this.navSettingIndex].setting.readmoreCss.style.color=value
    this.navigation[this.navSettingIndex].setting.readmoreCss.style['border-bottom']='2px solid'+value
    this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
  }
  
 }

 fontSizeChange(event: any, type: string) {

  this.inifont.forEach((ini) => {

      if (ini.nativeElement.classList.contains(type)) {

          ini.nativeElement.value = event.target.value;

      }
  });

  switch (type) {

      case 'title_change':

          this.navigation[this.navSettingIndex].setting.tittleCss.style['font-size'] = event.target.value + 'px';
          this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);
          break;

      case 'subtitle_change':

          this.navigation[this.navSettingIndex].setting.subtittleCss.style['font-size'] = event.target.value + 'px';
          this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

          break;

      case 'content_change':

        this.navigation[this.navSettingIndex].setting.contentCss.style['font-size'] = event.target.value + 'px';
        this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

        break;

    case 'link_change':

      this.navigation[this.navSettingIndex].setting.readmoreCss.style['font-size'] = event.target.value + 'px';
      this.sendRecord(this.navigation[this.navSettingIndex],this.navigation[this.navSettingIndex].type);

      break;

  }

}

sendRecord(setting:any, type:any){

   this.msg.sendMessage({'action':'sendNavSettings','records':setting,'type':type});

}

dividerVisibility(evt){

  this.sections[this.currentSectionIndex].isDividerOn=evt.target.checked

}

onDividerColorChange(value,id){

  if( this.sections[this.currentSectionIndex].selectedDividerColorID==id){
    this.sections[this.currentSectionIndex].selectedDividerColorID=-1
    this.sections[this.currentSectionIndex].dividerCss.style['background-color']='#000000'

  }else{
    this.sections[this.currentSectionIndex].selectedDividerColorID=id
    this.sections[this.currentSectionIndex].dividerCss.style['background-color']=value

  }
  
}

onSecBakColorChange(value,id){

  if(this.sections[this.currentSectionIndex].selectedBackColorID==id){
    this.sections[this.currentSectionIndex].selectedBackColorID=-1
    this.sections[this.currentSectionIndex].backgroundCss.style['background-color']='#000000'
  }else{
    this.sections[this.currentSectionIndex].selectedBackColorID=id
    this.sections[this.currentSectionIndex].backgroundCss.style['background-color']=value
  }
 
}



saveImageForNext(){


}


saveImageForSend(){


  
  if(this.templateName!=undefined && this.bannerImage!=undefined){

    //document.getElementById('capture').style.display='block';

    $('#render-snapshot').html($('#preview-modal').html());


    
    html2canvas(document.getElementById("render-snapshot")).then(canvas => {
     
      var width = document.getElementById('render-snapshot').offsetWidth;
      var height = document.getElementById('render-snapshot').offsetHeight;

      var tempcanvas=document.createElement('canvas');
      tempcanvas.width=width;
      tempcanvas.height=height;
      var context=tempcanvas.getContext('2d');
      context.drawImage(canvas, 0, 0, width, height);
      var link=document.createElement("a");
      link.href=tempcanvas.toDataURL('image/jpg');   //function blocks CORS

     // link.download = this.templateName+'.jpg';
    //  link.click();
      
      try{
        let res:any = link.href;
        let token:any = JSON.parse(atob(localStorage.getItem('token')));
        var data = new FormData();
        data.append( 'upload[0][content]',res);
        data.append( 'upload[0][name]',this.templateName);

        let obj={
          token:token,
          reqData:data
        }

        this.newsService.imageUpload(obj).subscribe( (res) =>{
       

          if(res.status=='success'){

          // document.getElementById('capture').style.display='none';

          //  this.snapImage = this.url+res.files[0].path;

          $('#render-snapshot').html('');

           this.snapImage = res.files[0].path;
           
          

           this.finalJson.sections.bannerImage=this.bannerImage;
           this.finalJson.sections.sectionData=this.sections;
           this.finalJson.sections.menuSetting=this.menuSetting;
           this.finalJson.image = this.snapImage;

           

           
     
           
          }

        })

      }catch(exec){
        this._router.navigate(['/login']);
      }
     
   }); 


    

  }else{
   console.log('template name and banner image can not be empty')
  }
   
  

  
}


cropCanvas(sourceCanvas,left,top,width,height){
  let destCanvas = document.createElement('canvas');
  destCanvas.width = width;
  destCanvas.height = height;
  destCanvas.getContext("2d").drawImage(
      sourceCanvas,
      left,top,width,height,  // source rect with content to crop
      0,0,width,height);      // newCanvas, same size as source rect
  return destCanvas;
}


onCheckChange(event){
  
  if(this.checkedval==true){
    this.finalJson['private']=1
   }else{
    this.finalJson['private']=0
   }

}

onExternalChange(){
  if(this.checkedExternal==true){
    this.finalJson['external']=1
   }else{
    this.finalJson['external']=0
   }
}

hasDynamicTextBlock(){
  return (this.sections || []).some((section) => section.type === 'dynamic_text_block');
}

prepareDynamicTextBlocks(){
  (this.sections || []).forEach((section) => {
    if(section.type === 'dynamic_text_block'){
      section.elements[0].navObject.id = '999';
      section.setting.readmoreCss.style = { display: 'none' };
    }
  });
  this.dynamicTextBoxContent = (this.sections || []).map((section) => section.type === 'dynamic_text_block' ? (section.description || '') : null);
}

dynamicTextBoxContentUpdate(content:string, pos:number){
  this.dynamicTextBoxContent[pos] = content;
  const section = this.sections[pos];
  section.description = content;
  // sendgrid.php builds the email from elements[0].navObject.description for one-column sections.
  section.elements[0].navObject.description = content;
}

saveJson(e:Event){

  // html2canvas cannot capture the TinyMCE iframes, so render the blocks as HTML first.
  if(this.templateName!=undefined && this.bannerImage!=undefined && this.hasDynamicTextBlock()){
    this.loader_image = true
    this.switchDynamicTextbox = true
    setTimeout(() => this.captureAndSave(e), 1000)
  }else{
    this.captureAndSave(e)
  }
}

captureAndSave(e:Event){


  this.loader_image = true
 
  //e.preventDefault();
 
  if(this.templateName!=undefined && this.bannerImage!=undefined){

    //document.getElementById('capture').style.display='block';

    //console.log($('#preview-modal').html());

    //$('#render-snapshot').html($('.right-newsletterarea').html());

    

     $('#hide_below_snapshot').hide();

     window.scrollTo(0,0);
    
    html2canvas(document.getElementById('ss2'),{ allowTaint: true, useCORS: true  
    }).then(canvas => {
     
      
        var tempcanvas=document.createElement('canvas');

        tempcanvas.width=canvas.width ;
        tempcanvas.height=canvas.height;
        var context=tempcanvas.getContext('2d');

       

     

       context.drawImage(canvas, 0, 0, tempcanvas.width,tempcanvas.height );


      var link=document.createElement("a");
      link.href=tempcanvas.toDataURL('image/png');   //function blocks CORS

    //  link.download = this.templateName+'.png';
      //link.click();


      $('#hide_below_snapshot').show();
      this.switchDynamicTextbox = false;
      


      try{
        let res:any = link.href;
        let token:any = JSON.parse(atob(localStorage.getItem('token')));
        var data = new FormData();
        data.append( 'upload[0][content]',res);
        data.append( 'upload[0][name]',this.templateName);

        let obj={
          token:token,
          reqData:data
        }

        this.newsService.imageUpload(obj).subscribe( (res) =>{
         // console.log('ffffkkkkkkkk',res)

          if(res.status=='success'){

            console.log("res=====save",res);


          // document.getElementById('capture').style.display='none';

          //  this.snapImage = this.url+res.files[0].path;

          //$('#render-snapshot').html('');

           this.snapImage = res.files[0].path;

           let country = []

           this.selectedCountry.map((x) => {
             country.push(x.value)
           })
     
           this.finalJson['country'] = country;

           this.finalJson.page='newsletter';
           this.finalJson.templateName = this.templateName;
           this.finalJson.image = this.snapImage;
           this.finalJson.sections.bannerImage=this.bannerImage;
           this.finalJson.sections.sectionData=this.sections;
           this.finalJson.sections.menuSetting=this.menuSetting;
           
           if(this.selectedGroup[0] !=undefined  &&  this.selectedGroup[0].key!=undefined){

            this.finalJson['templateId'] = this.selectedGroup[0].key;

          }  


           this.finalJson.sections['footer'] = this.footerDescription 
           this.finalJson.sections['header'] =   this.headerDescription 

         
            this.saveTemplate();
           
          }else{
            this._router.navigate(['/login']);
          }

        })

      }catch(exec){
        this._router.navigate(['/login']);
      }
     
     


   }); 

    

  }else{
   console.log('template name and banner image can not be empty')
  }
   
  
  
}

saveTemplate(){

  let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
  if(!tokenA) throw 'Error in parse';
  
  if(!JSON.parse(tokenA)) throw 'Error in json parse';

  tokenA = JSON.parse(tokenA);

   

   let reqdata={
    token:tokenA.token,
    reqData:this.finalJson,
   
   }
  this.newsService.newsletterData(reqdata).subscribe( (res) =>{

    this.loader_image = false

    console.log("template res=====",res);

    
    if(res.status=='success'){
      

      this.finalJson.id= res.id;

      if(this.showMsg){

        this.toastr.success('Newsletter is saved successfully !', '', {timeOut: 3000});

        this._router.navigate(['/newsletter']);


      }
     

    }else{

      if(res.message && res.errors.length > 0){
        for (var i=0; i < res.errors.length; i++) {
          this.toastr.error(res.message + ' for ' + res.errors[i].article_title, '', {timeOut: 4000});
        }
       
      }else{
        if(this.showMsg){

          this.toastr.success('Newsletter cant saved  !', '', {timeOut: 3000});
          
        }
      }


    }

  })

}

onGroupSelect(event:any){

  this.toastr.success('Newsletter Template is changed !', '', {timeOut: 3000});
  

  window.scrollTo(0, 0);
  
  let sectionsP:any =this.sections;
  
  
  try{

     let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      let data2={
        token:this.token, 
        details: {
          id:this.selectedGroup[0].key,
          'page':'newsletter'
        }
      } 

      let currentData = this.sections;
    
      this.templateService.getTemplateList(data2).subscribe( (elem)=>{


        if(elem.status =='success'){
          //  console.log('ranjj',elem.template)
          
          // this.newsletterid = elem.template[0].id;
          // this.templateName =  elem.template[0].name;
          // this.templateNumber = elem.template[0].templateNumber;
          // this.publish = elem.template[0].publish;
          if(elem.template[0].sections!=null && elem.template[0].sections.sectionData!=undefined){
               
          //  for(let i=0;i< elem.template[0].sections.sectionData.length;i++){
              
          //     // console.log('fhgfg',elem.template[0].sections.sectionData[i].type,currentData[i])

          //     if(currentData[i]!= undefined &&   elem.template[0].sections.sectionData[i].type==currentData[i].type){
          //       // console.log('ddd',currentData[i].type,currentData[i])
          //       elem.template[0].sections.sectionData[i].elements = currentData[i].elements
          //     }
          //  }
             this.sections = elem.template[0].sections.sectionData;
             this.prepareDynamicTextBlocks();
             this.footerDescription = elem.template[0].sections.footer;
             this.headerDescription =  elem.template[0].sections.header;
             console.log("section 2 ====",this.sections);


            // elem.template[0].sections.sectionData.forEach(element => {


              
            // });
           
            // console.log(this.sections);


          }
        }

      })

  }catch(exec){

  }

  
}

deletedBox(postion:any,secIndx:any){

  
  this.sections[secIndx].elements[postion].navObject ={}


}


}
